export enum ECreationTypes {
  CONVERTER = 'CONVERTER',
  OPTIMIZATOR = 'OPTIMIZATOR',
  OCR = 'OCR',
  MERGER = 'MERGER',
  TRANSLATE = 'TRANSLATE',
  REMOVE_WATERMARK = 'REMOVE_WATERMARK'
}
